import React from 'react';
import PropTypes from 'prop-types';
import CSSReset from '@tds/core-css-reset';

import Header from './header';
import Footer from './footer';
import { USER_RIGHTS } from '../utils/request';

const Layout = ({ locale, children, profile }) => {
  const userName = profile
    ? `${profile.first_name} ${profile.last_name}`
    : undefined;
  const userRights = profile ? USER_RIGHTS[profile.role.name] : undefined;

  return (
    <>
      <CSSReset />
      <Header locale={locale} userName={userName} userRights={userRights} />
      <div style={{ marginTop: '5rem' }}>{children}</div>
      <Footer disclaimer={false} />
    </>
  );
};

Layout.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  profile: PropTypes.object.isRequired
};

export default Layout;
